import { FC } from 'react';

type Props = {
	className?: string;
};

const ClockEmptyIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.99998 18.0002C14.4183 18.0002 18.0001 14.4184 18.0001 10.0001C18.0001 5.58176 14.4183 2 9.99998 2C6.4178 2 3.41932 4.35434 2.3999 7.60006H4.39992'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10 6.7998V9.99984L11.6 11.5999'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2 10C2 10.2698 2.01216 10.5367 2.03595 10.8M7.60006 18.0001C7.32677 17.9102 7.05982 17.8052 6.80005 17.6863M2.96752 14C2.81325 13.7028 2.67563 13.3947 2.55598 13.077M4.265 15.8453C4.50955 16.1087 4.77048 16.3553 5.04607 16.5834'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ClockEmptyIcon;
